import { render, staticRenderFns } from "./SideBarFinance.vue?vue&type=template&id=32b9e6b1"
import script from "./SideBarFinance.vue?vue&type=script&lang=js"
export * from "./SideBarFinance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports